import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { OfferOption, Reporter } from '@utils/backend-api/subscribe';

import { SubscribeProps } from '../Subscribe';
import Content from './Content';

const queryClient = new QueryClient();

export interface SubscribeTestProps extends SubscribeProps {
  monthlyOffer: OfferOption;
  reporters: Reporter[];
  ypOffer: OfferOption;
}
const SubscribeTest = (props: SubscribeTestProps) => {
  const {
    initialCurrentUser,
    isGdprRequired,
    isYPEligible,
    stripeCustomerId,
    subscriptionStatus,
    userDobVerified,
    userEmail,
    userFullName,
    userId,
    userNextBillingDate,
  } = props;

  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprRequired}>
      <SubscribeFormProvider
        user={{
          dobVerified: userDobVerified,
          email: userEmail,
          id: userId,
          isYPEligible,
          name: userFullName,
          nextBillingDate: userNextBillingDate,
          stripeCustomerId,
          subscriptionStatus,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Content {...props} />
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default SubscribeTest;
